import type { HTMLAttributes, ReactNode } from 'react';

type Tone = 'ok' | 'info' | 'warn' | 'fail';

/**
 * Spec 230 — Kridt's chip. Four tones, the shared target the seven badges
 * restyle onto. A neutral chip (no `tone`) uses `.hub-chip` alone.
 */
export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  children?: ReactNode;
}

export function Chip({ tone, className, children, ...rest }: ChipProps) {
  const cls = ['hub-chip', tone ? `hub-chip--${tone}` : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
}
